import { useQuery as defaultUseQuery, useMutation as defaultUseMutation, } from "@apollo/react-hooks";
import { defaultCurrency } from "@zapier/currency";
import { useAutoUpgrade, useCurrencies, useCurrentAccount, } from "@zapier/upsells/esm/hooks";
import { useAppLogo, useExtendTrial, usePaymentSource, usePlanForUpgradeReason, } from ".";
const getActiveTrialType = (currentAccount) => {
    if (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.isTrialingCompanies) {
        return "Company";
    }
    else if (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.isTrialingTeams) {
        return "Team";
    }
    else if (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.isTrialing) {
        return "Professional";
    }
    else {
        return undefined;
    }
};
export const useUpgradeModal = ({ appName, shouldAutoUpgrade, upgradeReason, useMutation = defaultUseMutation, useQuery = defaultUseQuery, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { currencies, error: currenciesError, isLoading: isLoadingCurrencies, } = useCurrencies({ useQuery });
    const { currentAccount, error: accountError, isLoading: isLoadingAccount, } = useCurrentAccount({ useQuery });
    const { canExtendTrial, error: extendTrialError, extendTrial, isLoading: isLoadingExtendTrial, } = useExtendTrial({
        account: currentAccount,
        reason: upgradeReason,
        shouldAutoUpgrade,
        useMutation,
    });
    const { autoUpgradeToPlan, error: autoUpgradeError, isAutoUpgradeEnabled, isLoading: isLoadingAutoUpgrade, } = useAutoUpgrade({ useMutation, useQuery });
    const { error: paymentSourceError, isLoading: isLoadingPaymentSource, isPaymentMethodProvided, } = usePaymentSource({ accountId: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.id, useQuery });
    const activeTrialType = getActiveTrialType(currentAccount);
    const { error: planForUpgradeReasonError, isLoading: isLoadingPlanForUpgradeReason, plan: upgradeToPlan, } = usePlanForUpgradeReason({
        account: currentAccount,
        activeTrialType,
        upgradeReason,
        useQuery,
    });
    const { appLogoUrl, error: appLogoError, isLoading: isLoadingAppLogo, } = useAppLogo({
        appName,
        skip: !appName,
        useQuery,
    });
    return {
        account: currentAccount,
        accountCurrency: (_a = currencies === null || currencies === void 0 ? void 0 : currencies.find((c) => c.name === (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.currency))) !== null && _a !== void 0 ? _a : defaultCurrency,
        activeTrialType,
        appLogoUrl,
        autoUpgradeToPlan,
        billingPeriodEndDate: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.periodEndDate,
        billingPeriodStartDate: currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.periodStartDate,
        canExtendTrial,
        currentUserRole: (_b = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.currentUserRole) !== null && _b !== void 0 ? _b : "member",
        destinationPlan: upgradeToPlan,
        enabledTrialExtensions: (_c = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.enabledTrialExtensions) !== null && _c !== void 0 ? _c : [],
        error: (_h = (_g = (_f = (_e = (_d = accountError !== null && accountError !== void 0 ? accountError : appLogoError) !== null && _d !== void 0 ? _d : autoUpgradeError) !== null && _e !== void 0 ? _e : currenciesError) !== null && _f !== void 0 ? _f : extendTrialError === null || extendTrialError === void 0 ? void 0 : extendTrialError.message) !== null && _g !== void 0 ? _g : paymentSourceError) !== null && _h !== void 0 ? _h : planForUpgradeReasonError,
        extendTrial,
        isAutoUpgradeEnabled,
        isLoading: isLoadingAccount ||
            isLoadingAppLogo ||
            isLoadingAutoUpgrade ||
            isLoadingCurrencies ||
            isLoadingExtendTrial ||
            isLoadingPaymentSource ||
            isLoadingPlanForUpgradeReason,
        isPaymentMethodProvided,
        taskBufferOverride: (_j = currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.taskBufferOverride) !== null && _j !== void 0 ? _j : 1,
        tasksRemaining: currentAccount
            ? (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.usage.tasks.limit) - (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.usage.tasks.total)
            : 0,
    };
};

// @zapier/upsells@8.0.1 (466b4077f)
